module.exports = __webpack_public_path__ + "img/linkedin-light.aba7828f.svg";